import script from "./ModalEscolha.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEscolha.vue?vue&type=script&setup=true&lang=js"

import "./ModalEscolha.vue?vue&type=style&index=0&id=6f202e6e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f202e6e"]])

export default __exports__